import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const Box = styled.div`
  .cont-title {
    margin: 20px 0 0 16px;
    width: 234px;
    height: 32px;
    border-radius: 4px;
  }

  /* 추천 상품 : 가로 스크롤 1줄 */
  .box-prd {
    ${mixin.flex({ direction: 'column', align: 'flex-start' })};
    margin-top: 16px;
    overflow: auto hidden;
    overscroll-behavior: contain auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .list {
      ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })};
      padding: 0 16px;
      column-gap: 6px;

      .item {
        flex: none;

        .thum {
          width: 104px;
          height: 138px;
          border-radius: 4px;
        }

        .text01 {
          margin-top: 8px;
          width: 90px;
          height: 14px;
          border-radius: 4px;
        }

        .text02 {
          margin-top: 4px;
          width: 90px;
          height: 14px;
          border-radius: 4px;
        }

        .text03 {
          margin-top: 4px;
          width: 70px;
          height: 18px;
          border-radius: 4px;
        }
      }
    }
  }

  @media ${({ theme }) => `${theme.media.smMax}, ${theme.media.md}`} {
    .cont-title {
      margin: ${mixin.pxToVw('20 0 0 16')};
      width: ${mixin.pxToVw('234')};
      height: ${mixin.pxToVw('32')};
      border-radius: ${mixin.pxToVw('4')};
    }

    .box-prd {
      margin-top: ${mixin.pxToVw('16')};

      .list {
        padding: ${mixin.pxToVw('0 16')};
        column-gap: ${mixin.pxToVw('6')};

        .item {
          .thum {
            width: ${mixin.pxToVw('104')};
            height: ${mixin.pxToVw('138')};
            border-radius: ${mixin.pxToVw('4')};
          }

          .text01 {
            margin-top: ${mixin.pxToVw('8')};
            width: ${mixin.pxToVw('90')};
            height: ${mixin.pxToVw('14')};
            border-radius: ${mixin.pxToVw('4')};
          }

          .text02 {
            margin-top: ${mixin.pxToVw('4')};
            width: ${mixin.pxToVw('90')};
            height: ${mixin.pxToVw('14')};
            border-radius: ${mixin.pxToVw('4')};
          }

          .text03 {
            margin-top: ${mixin.pxToVw('4')};
            width: ${mixin.pxToVw('70')};
            height: ${mixin.pxToVw('18')};
            border-radius: ${mixin.pxToVw('4')};
          }
        }
      }
    }
  }
`;
